import { mapGetters, mapMutations } from "vuex";
import {
  getCurrentDate,
  IsStoreOpenAtTime,
} from "@/api/helpers/datetimeHelper";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_DINEIN,
  CONSTANT_ORDER_TYPE_PICKUP,
} from "@/constants/strings";
import { orderTypeHelper } from "@/api/helpers/orderTypeHelper";
export default {
  computed: {
    ...mapGetters(["viewConfig", "selectedCompany", "getSelectedMenuType"]),
    storeSupportsDelivery() {
      let now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      let storeOpen = IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
      if (!this.selectedCompany.EnablePreoderForDelivery) {
        now = now.plus({
          minutes: this.selectedCompany.OrderPreparationTime,
        });
        storeOpen = IsStoreOpenAtTime(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          this.selectedCompany.IsInOperation,
          now
        );
      }
      return (
        this.viewConfig.Delivery &&
        (storeOpen || this.selectedCompany.EnablePreoderForDelivery)
      );
    },
    storeSupportsDinein() {
      let now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      now = now.plus({
        minutes: this.selectedCompany.OrderPreparationTime,
      });
      let storeOpen = IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
      return this.viewConfig.EatIn && storeOpen;
    },
    storeSupportsPickup() {
      let now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      let storeOpen = IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
      if (!this.selectedCompany.EnablePreoderForPickup) {
        now = now.plus({
          minutes: this.selectedCompany.OrderPreparationTime,
        });
        storeOpen = IsStoreOpenAtTime(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          this.selectedCompany.IsInOperation,
          now
        );
      }
      return (
        this.viewConfig.PickUp &&
        (storeOpen || this.selectedCompany.EnablePreoderForPickup) &&
        !this.pickupDisabled
      );
    },
    isPickup() {
      return this.getSelectedMenuType === CONSTANT_ORDER_TYPE_PICKUP;
    },
    isDelivery() {
      return this.getSelectedMenuType === CONSTANT_ORDER_TYPE_DELIVERY;
    },
    isDineIn() {
      return this.getSelectedMenuType === CONSTANT_ORDER_TYPE_DINEIN;
    },
    pickupString() {
      return CONSTANT_ORDER_TYPE_PICKUP;
    },
    deliveryString() {
      return CONSTANT_ORDER_TYPE_DELIVERY;
    },
    dineInString() {
      return CONSTANT_ORDER_TYPE_DINEIN;
    },
    displayOrderSelect() {
      return (
        this.storeSupportsPickup ||
        this.storeSupportsDelivery ||
        this.storeSupportsDinein
      );
    },
  },
  methods: {
    ...mapMutations([
      "setSelectedMenuType",
      "setOrderTypeModalDisplay",
      "setIsDelivery",
    ]),
    setOrderType(e) {
      if (!e) return;
      const orderType = e.target.value;
      switch (orderType) {
        case CONSTANT_ORDER_TYPE_DELIVERY:
          this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DELIVERY);
          this.setIsDelivery(true);
          orderTypeHelper.setOrderType(CONSTANT_ORDER_TYPE_DELIVERY);
          this.$nextTick(() => {
            this.setOrderTypeModalDisplay(true);
            this.$forceUpdate();
          });
          break;
        case CONSTANT_ORDER_TYPE_DINEIN:
          this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
          this.setIsDelivery(false);
          orderTypeHelper.setOrderType(CONSTANT_ORDER_TYPE_DINEIN);
          this.$nextTick(() => {
            this.setOrderTypeModalDisplay(false);
          });
          break;
        case CONSTANT_ORDER_TYPE_PICKUP:
          this.setSelectedMenuType(CONSTANT_ORDER_TYPE_PICKUP);
          this.setIsDelivery(false);
          orderTypeHelper.setOrderType(CONSTANT_ORDER_TYPE_PICKUP);
          this.$nextTick(() => {
            this.setOrderTypeModalDisplay(false);
          });
          break;
      }
    },
  },
};
